import { DebouncedTextInput } from "ra-friendsofbabba";
import React from "react";
import { get } from "lodash";
import { required } from "ra-core";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";

const PatentTypeOtherInput = (props) => {
  const formState = useFormState();
  const patentTypeId = formState.values?.patent_type_id;
  const isCustom = useSelector((state) =>
    get(state, `admin.resources.patent-types.data.${patentTypeId}.is_custom`)
  );
  if (!isCustom) {
    return null;
  }
  return (
    <DebouncedTextInput {...props} validate={required()} maxLength={250} />
  );
};
export default PatentTypeOtherInput;
